module.exports = __webpack_public_path__ + "static/media/about.fd378d1c.svg";